<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button *ngIf="!visibilitySpinnerSave" [disabled]="disableSave" type="button" class="btn btn-outline-success" (click)="onSave()" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinnerSave" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
        <button *ngIf="hasAnularAccess && !visibilitySpinnerAnular" type="button" class="btn btn-outline-success" (click)="onAnular()" title="Anular"><i class="fa fa-ban"></i> Anular</button>
        <button *ngIf="visibilitySpinnerAnular" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Anulando
        </button>

        <div *ngIf="solicitudCam && !esPeriodoVigente" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo no vigente</label>
        </div>
        <div *ngIf="!plazoPresentacionVigente" class="ms-1 nota-info warning">
            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Plazo de Presentación no vigente</label>
        </div>
    </form>
</nav>

<app-solicitud-cam-edit [solicitudCam]="solicitudCam" [formGroup]="formGroup" [readonly]="readonly" [variedades]="variedades" [usuarioExterno]="usuarioExterno"
                        [campanias]="campanias" [periodos]="periodos" [CAs]="CAs" [tiposSolicitud]="tiposSolicitud" [EAs]="EAs"
                        (campaniaSelected)="onCampaniaSelected($event)"
                        (periodoSelected)="onPeriodoSelected($event)" (caSelected)="onCASelected($event)">
</app-solicitud-cam-edit>
